import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DetailList } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const infoDetailIconStyle = css`
  margin-left: 8px;
`;

export const TopWrapper = styled.div`
  margin-top: -50px;
  min-height: 300px;
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
`;

export const TopFlexWrapper = styled.div`
  display: flex;

  ${mediaQuery('medium')} {
    flex-direction: column;
  }
`;

export const TopSlideshowWrapper = styled.div`
  width: 50%;
  height: 100%;
  padding: 30px;
  ${mediaQuery('medium')} {
    padding-top: 15px;
    padding-bottom: 0;
    width: 100%;
  }
`;

export const TopDetailsWrapper = styled.div`
  padding: 20px;
  flex-grow: 1;
`;

export const TopButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;
  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 100px;
  }

  ${mediaQuery('medium')} {
    & > *:not(:last-child) {
      margin-right: 30px;
    }
  }
  ${mediaQuery('tablet')} {
    flex-direction: column;
    margin-right: 0;
    & > *:not(:last-child) {
      margin-bottom: 30px;
    }
  }
`;

export const BreedCardWrapper = styled.div`
  min-width: 300px;
  max-width: 300px;
  ${mediaQuery('tablet')} {
    max-width: 100%;
    width: 100%;
  }
`;

// Contact card

export const ContactContainer = styled.div`
  margin-bottom: 50px;
  display: flex;
  & > *:not(:last-child) {
    margin-right: 30px;
  }
  align-items: center;
  padding: 30px;
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);

  #card-contact {
    padding: 0;
    background: none;
    box-shadow: none;
    flex-grow: 1;
  }

  ${mediaQuery('medium')} {
    flex-direction: column;
    align-items: stretch;
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
`;

export const ContactImgWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContactLink = styled.a`
  white-space: nowrap;
`;

export const ContactImg = styled.img`
  margin-bottom: 15px;
  border-radius: 100%;
  width: 150px;
  height: 150px;
  object-fit: cover;
  -webkit-touch-callout: none;
  -webkit-user-select: none;

  ${mediaQuery('medium')} {
    margin: inherit auto;
  }

  ${mediaQuery('tablet')} {
    width: 100px;
    height: 100px;
  }
`;

export const ContactDetailList = styled(DetailList)`
  width: 100%;
  & > div {
    width: 45%;
    margin: 0 2.5%;
    display: inline-flex;

    ${mediaQuery('tablet')} {
      width: 100%;
    }
  }
`;

export const VerticalMargin = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
`;
